import ComponentLoader from '@inventis/componentloader';

(new ComponentLoader()).loadComponentsWithinElement(document);
